@if (header) {
  <h5>{{ header }}</h5>
}
<ng-content></ng-content>
